import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '../env';

export interface Projects {
    id: number,
    name: string;
    description: string;
    stack: string;
		link: string;
  }

export const portfolioApi = createApi({
	reducerPath: 'portfolioApi',
	baseQuery: fetchBaseQuery({
		baseUrl: environment.apiUrl}),
		endpoints: (builder) => ({
			getPortfolioItems: builder.query<Projects[], void>({
				query: () => '/projects',
			}),
		}),
	});

export const { useGetPortfolioItemsQuery } = portfolioApi;

